import type { Floorplan } from '@vibesites/schema';
import { parseBedCount } from './bedroomOptions';

const TOWNHOME_PATTERN = /\btown\s?(home|house)s?\b/i;

/** Townhome plans are identified by wording in the name, code, or description. */
export function isTownhome(plan: Floorplan): boolean {
  return [plan.floorplan_name, plan.floorplan_code, plan.floorplan_description].some(
    (text) => Boolean(text && TOWNHOME_PATTERN.test(text)),
  );
}

export interface FloorplanTypeFilter {
  /** Bedroom count to match (0 = studio). Ignored when `townhomes` is set. */
  bedrooms?: number;
  townhomes?: boolean;
}

export function matchesFloorplanType(plan: Floorplan, { bedrooms, townhomes }: FloorplanTypeFilter): boolean {
  if (plan.floorplan_is_disabled) return false;
  if (townhomes) return isTownhome(plan);
  if (bedrooms == null) return true;
  return parseBedCount(plan.floorplan_beds_min) === bedrooms;
}

/** Floor plan type pages, keyed by page alias. Shared by the page sections and the nav. */
export const FLOORPLAN_TYPE_PAGES: Record<string, FloorplanTypeFilter> = {
  studios: { bedrooms: 0 },
  '1-bedroom': { bedrooms: 1 },
  '2-bedrooms': { bedrooms: 2 },
  '3-bedrooms': { bedrooms: 3 },
  townhomes: { townhomes: true },
};
